import { render, staticRenderFns } from "./onBoardingScreen.vue?vue&type=template&id=45c42e7b&"
import script from "./onBoardingScreen.vue?vue&type=script&lang=js&"
export * from "./onBoardingScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports